import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface EmailStepProps {
  onNext: (email: string) => void;
  defaultValue?: string;
}
export function EmailStep({
  onNext,
  defaultValue = ''
}: EmailStepProps) {
  const [email, setEmail] = useState(defaultValue);
  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) onNext(email);
  };
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-38">
      <div className="text-center mb-3 sm:mb-5" data-id="element-39">
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-40">
          ¿Cuál es tu correo electrónico?
        </h2>
        <p className="text-gray-600 text-xs sm:text-sm" data-id="element-41">
          A dónde enviaremos tu cotización
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-3" data-id="element-42">
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" className="w-full p-3.5 bg-white rounded-lg border-2 border-gray-200 focus:border-primary focus:ring-0 outline-none text-base transition-colors" required data-id="element-43" />
        <motion.button whileHover={{
        scale: isValid ? 1.02 : 1
      }} whileTap={{
        scale: isValid ? 0.98 : 1
      }} type="submit" disabled={!isValid} className="w-full bg-primary hover:bg-primary-hover text-white font-bold text-lg py-4 px-6 rounded-lg shadow-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-44">
          Obtener Mi Cotización
        </motion.button>
      </form>

      <div className="mt-2 text-center text-xs text-gray-500" data-id="element-45">
        <p data-id="element-46">No spam. Solo tu cotización personalizada.</p>
      </div>
    </div>;
}